module.exports = __webpack_public_path__ + "img/1alB-n-gu'n.833933cc.jpg";